import { useEffect } from "react";
import AOS from "aos";
import ContactForm from "../../components/contact_form";
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import Breadcum from "../../components/breadcum";
import Maps from "../../components/maps";
import ContactCard from "../../components/contact/contact_card";

export default function Contact() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section id="contacto" className="bg-neutral-100">
      <div className="mx-auto max-w-screen-2xl px-6 lg:px-8 py-36">
        <div data-aos="fade-right">
          <Breadcum text="Contáctanos" />
          <h2 className="text-4xl font-bold mt-2 mb-4 text-gray-800 leading-tight">
            Ponte en contacto con nosotros
          </h2>
          <p className="text-gray-700 mb-4">
            Si deseas más información sobre nuestros servicios, contáctanos a
            través de los siguientes medios:
          </p>
        </div>

        <div className="grid grid-cols-12 gap-8 mb-10">
          <div data-aos="fade-up" className="col-span-12 md:col-span-4 w-full">
            <ContactCard
              title={"Correo Electrónico"}
              description={"contacto@seguridadbp.com"}
              icon={<FaEnvelope />}
            />
          </div>
          <div data-aos="fade-up" data-aos-delay="200" className="col-span-12 md:col-span-4 w-full">
            <ContactCard
              title={"Dirección"}
              description={
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Ave.+%C3%81lvaro+Obreg%C3%B3n+%231033,+Local+105,+Colonia+Moderna,+C.P.+84055,+H.+Nogales,+Sonora"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 transition"
                >
                  Ave. Álvaro Obregón #1033, Local 105, Colonia Moderna, C.P.
                  84055, H. Nogales, Sonora.
                </a>
              }
              icon={<FaMapMarkerAlt />}
            />
          </div>
          <div data-aos="fade-up" data-aos-delay="400" className="col-span-12 md:col-span-4 w-full">
            <ContactCard
              title={"Teléfonos"}
              description={"Oficina: 631-209-1989"}
              description2={"Celular: 631-193-4479"}
              icon={<FaPhoneAlt />}
            />
          </div>
        </div>
        <div className="grid md:grid-cols-12 gap-12 items-center">
          <div data-aos="zoom-in" className="col-span-2 md:col-span-6">
            <Maps />
          </div>
          <div data-aos="fade-up" className="col-span-2 md:col-span-6">
            <ContactForm
              placeHolder_nombre="Nombre"
              placeHolder_btn="Contáctanos"
              placeHolder_correo="Correo"
              placeHolder_mensaje="Mensaje"
              placeHolder_telefono="Teléfono"
            />
          </div>
        </div>

      </div>
    </section>
  );
}
